import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Layout } from 'antd'
import HeaderComponent from '../../components/HeaderComponent/HeaderComponent'
import StaticPageContent from './StaticPageContent'

type Props = {}

const StaticPage: React.FC<Props> = () => {
  const navigate = useNavigate()
  const onHome = () => navigate('/')

  return (
        <Layout style={{ minHeight: '100vh' }}>
            <HeaderComponent onHome={onHome}/>
            <Layout.Content style={{ padding: '40px' }}>
                <StaticPageContent/>
            </Layout.Content>
        </Layout>
  )
}

export default StaticPage
